import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";
import { env } from "@/config/env";

export const initializeSentry = () => {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    tracesSampleRate: 0.5,
    tracePropagationTargets: ["http://localhost:3002", "https://alpha.hiremaven.ai/", "https://app.hiremaven.ai/"],
    environment: env.ENVIRONMENT_NAME
  });
};
